import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard } from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import './css/general.css';
import styles from './css/Results.module.css';


interface LevelProps extends RouteComponentProps {
  // Define the props here
}
interface LevelState {
  // Define the state here
  challengeList: any[];
}



class LevelPage extends React.Component<LevelProps, LevelState>{
  constructor(props: LevelProps) {
    super(props);

    this.state = {
        challengeList: JSON.parse(localStorage.getItem("challengeList") as string),
    }
  }



goToChallengeResult(challengeId: number, challengeTitle: string, challengeScore: number, questions: number){
    const {history} = this.props;
    localStorage.setItem("challengeId", "" + challengeId)
    localStorage.setItem("challengeTitle", "" + challengeTitle)
    localStorage.setItem("challengeScore", "" + challengeScore)
    localStorage.setItem("amountOfQuestions", "" + questions)
    history.push("/challengeresult");
}


  render() {
    let challengeDone:any[] = [];
    this.state.challengeList.forEach((challenge) => {
      if(challenge.challengeScore >= 0) {
        challengeDone.push(
        <IonCard 
        className={`${styles.panel} ${styles.quiz}`}
        key={challenge.challengeId}
        onClick={() => this.goToChallengeResult(challenge.challengeId, challenge.challengeTitle, challenge.challengeScore, challenge.questions)}
        >
            <p className={(styles.challengeTitle)}>{challenge.challengeTitle}</p>
            <p className={(styles.text)}>Klik hier om je reultaten voor deze challenge te bekijken</p>
        </IonCard>
        )
      } else {
        challengeDone.push(
        <IonCard 
        className={`${styles.panel} ${styles.quiz} ${styles.disabledPanel}`}
        key={challenge.challengeId}>
            <p className={(styles.challengeTitle)}>{challenge.challengeTitle}</p>
            <p className={(styles.text)}>Je hebt deze challenge niet voltooid</p>
        </IonCard>
        )
      }
    });
      

    return (
      <IonPage>
        <IonHeader class="ion-no-border">
          <IonToolbar>
          <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
            <IonTitle>Challenges</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
            <div className= {(styles.quizNames)}>
                {challengeDone}
            </div>
        </IonContent>
      </IonPage>
    );
  }
};

export default withRouter(LevelPage)
